import React, { useEffect, useState } from "react";
import './contact.css'; 

function Contact() {

  const [contact, setContact] = useState({});

  useEffect(() => {
    fetch("https://dashboard.jyotirvani.com/api/contactpage")
      .then((res) => res.json())
      .then((data) => {
        if (data.status && data.data) {
          setContact(data.data);
        }
      })
      .catch((error) => console.error("Error fetching contact info:", error));
  }, []);

  return (
    <div className="ra-contact-main">
    <div className="container contact-container">
      <div className="ra-contact-heading">
      <h2 className="contact-heading">Get in touch</h2>
      <p className="contact-subtext">
        We're always on the lookout to work with new clients. If you're interested in working with us, please get in touch in one of the following ways.
      </p>
      </div>

    <div className="ra-contact-form-main">
      {/* Contact Info */}
      <div className="contact-info-box">
 
      {contact.address && (
        <div className="contact-info-item">
          <div className="contact-icon">
            <i className="bi bi-geo-alt-fill"></i>
          </div>
          <div className="contact-text">
            <h5>Address</h5>
            <address>{contact.address}</address>
          </div>
        </div>
      )}

      {contact.phno && (
        <div className="contact-info-item">
          <div className="contact-icon">
            <i className="bi bi-telephone-outbound"></i>
          </div>
          <div className="contact-text">
            <h5>Phone</h5>
            <p>
              <a
                className="link-secondary text-decoration-none"
                href={`tel:${contact.phno}`}
              >
                 {contact.phno}
              </a>
            </p>
          </div>
        </div>
      )}

      {contact.email && (
        <div className="contact-info-item">
          <div className="contact-icon">
            <i className="bi bi-envelope-at"></i>
          </div>
          <div className="contact-text">
            <h5>Email</h5>
            <p>
              <a
                className="link-secondary text-decoration-none"
                href={`mailto:${contact.email}`}
              >
                {contact.email}
              </a>
            </p>
          </div>
        </div>
      )}
 

        <div className="contact-info-item">
          <div className="contact-icon">
            <i className="bi bi-alarm"></i>
          </div>
          <div className="contact-text">
            <h5>Opening Hours</h5>
            <p className="mb-1 text-secondary">
              <strong>Mon - Fri:</strong> 9am - 5pm
            </p>
            <p className="mb-0 text-secondary">
              <strong>Sat - Sun:</strong> 9am - 2pm
            </p>
          </div>
        </div>
      </div>

      {/* Contact Form */}
     <div className="contact-form-box">
  <form>
    <div className="mb-3">
      <label htmlFor="fullname" className="form-label">
        Full Name <span className="text-danger">*</span>
      </label>
      <input type="text" className="form-control" id="fullname" required />
    </div>

    <div className="mb-3 col-12 col-md-6 float-start pe-md-2">
      <label htmlFor="email" className="form-label">
        Email <span className="text-danger">*</span>
      </label>
      <div className="input-group">
        {/* <span className="input-group-text"><i className="bi bi-envelope"></i></span> */}
        <input type="email" className="form-control" id="email" required />
      </div>
    </div>

    <div className="mb-3 col-12 col-md-6 float-start ps-md-2">
      <label htmlFor="phone" className="form-label">
        Phone Number
      </label>
      <div className="input-group">
        {/* <span className="input-group-text"><i className="bi bi-telephone"></i></span> */}
        <input type="tel" className="form-control" id="phone" />
      </div>
    </div>

    <div className="clearfix"></div>

    {/* New DOB field */}
    <div className="mb-3 col-12 col-md-4 float-start pe-md-2">
      <label htmlFor="dob" className="form-label">
        Date of Birth <span className="text-danger">*</span>
      </label>
      <input type="date" className="form-control" id="dob" required />
    </div>

    {/* New Time field */}
    <div className="mb-3 col-12 col-md-4 float-start px-md-2">
      <label htmlFor="time" className="form-label">
        Time of Birth <span className="text-danger">*</span>
      </label>
      <input type="time" className="form-control" id="time" required />
    </div>

    {/* New Place field */}
    <div className="mb-3 col-12 col-md-4 float-start ps-md-2">
      <label htmlFor="place" className="form-label">
        Place of Birth <span className="text-danger">*</span>
      </label>
      <input type="text" className="form-control" id="place" required />
    </div>

    <div className="clearfix"></div>

    <div className="mb-3">
      <label htmlFor="message" className="form-label">
        Tell Problem In Short <span className="text-danger">*</span>
      </label>
      <textarea className="form-control" id="message" rows="4" required></textarea>
    </div>

    <div className="mb-3 ra-contact-from">
      <button type="submit" className="btn btn-primary px-4">
        Send Message
      </button>
    </div>
  </form>
</div>

      </div>
    </div>
    </div>
  );
}

export default Contact;
